import moment from 'moment';

const BUCKET_NAME = 'registered';
const ANY_TEXT = 'Any';
const CUSTOM_TEXT = 'Custom';

export default class ThingRegisteredController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.selectedOption = null;
        this.customAfter = moment().subtract(1, 'week').toDate();
        this.customBefore = moment().toDate();
        this.anyText = ANY_TEXT;
        this.customText = CUSTOM_TEXT;
        this.values = {
            'Today': moment().format('YYYY-MM-DD'),
            'Yesterday': moment().subtract(1, 'day').format('YYYY-MM-DD'),
            'Last 30 days': moment().subtract(30, 'days').format('YYYY-MM-DD'),
            'Last 60 days': moment().subtract(60, 'days').format('YYYY-MM-DD'),
            'Last 90 days': moment().subtract(90, 'days').format('YYYY-MM-DD')
        };
    }

    isAnySelected() {
        return this.selectedOption === ANY_TEXT;
    }

    isCustomSelected() {
        return this.selectedOption === CUSTOM_TEXT;
    }

    onChange() { // eslint-disable-line consistent-return
        if (this.isAnySelected()) {
            return this.removeItemFromBucket(
                this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                })
            );
        }

        const value = {};

        if (this.isCustomSelected()) {
            value.after = moment(this.customAfter).format('YYYY-MM-DD');
            value.before = moment(this.customBefore).format('YYYY-MM-DD');
        } else {
            value.after = this.selectedOption;
        }

        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value
                }
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-registered/thing-registered.controller.js